import { Menu } from 'lucide-react';

interface MobileHeaderProps {
  onMenuClick: () => void;
  title: string;
  userEmail?: string;
}

export function MobileHeader({ onMenuClick, title, userEmail }: MobileHeaderProps) {
  return (
    <header className="md:hidden fixed top-0 left-0 right-0 h-14 bg-night border-b border-stone/30 flex items-center px-4 z-30">
      <button
        onClick={onMenuClick}
        className="p-2.5 text-parchment hover:bg-stone/30 rounded-lg transition-colors"
        aria-label="Open menu"
        aria-expanded={false}
      >
        <Menu size={20} />
      </button>
      <div className="flex-1 ml-3">
        <h1 className="font-display text-base text-parchment">{title}</h1>
        {userEmail && <p className="text-mist/70 text-xs truncate max-w-[200px]">{userEmail}</p>}
      </div>
    </header>
  );
}
